import React, {useState, useEffect} from 'react';
import './App.css';
import './css/Main.css';
import Main from "./Screens/Main/Main";

import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import Home from "./Screens/Home/Home";
import Footer from "./components/Footer/Footer"
import { Popup, Banner, Card } from "popupio";
import "popupio/build/static/css/index.css";

const App: React.FC = () => {
  const [isShowPopup, setShowPopup] = useState(true);
  const [isShowCard, setShowCard] = useState(false);
  const [isShowBanner, setShowBanner] = useState(true);
  useEffect(() => {
    setTimeout(setShowCard, 10000, !isShowCard)
  },[])
  return (
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
        </Switch>
        <Card 

          customHeaderStyle={{backgroundColor:"#5bc0de", margin:"auto 0", textAlign:"center", width:"100%"}}
          bodyClick={() => setShowCard(!isShowCard)}
          isShow={isShowCard}
          button={"Check it here 👇"}
          isCanelable={true}

          onButtonClick={() => window.open("https://popupio.com/", '_blank')}
          custom
          title="Hey There! 👋👋👋"
          body={
            <div style={{textAlign:"left", margin:"auto 0"}}>
              <p style={{color:"black", fontWeight:"bold", textAlign:"left"}}>
                Did you liked tinyScratchpad? Maybe you will love my new product!
              </p>
              <p style={{color:"black", textAlign:"left"}}>
                Ever needed to build your own popups and banners? This is a css nightmare! 
                This is why I created <span style={{fontWeight:"bold"}}>popupio</span>! Add popups and banners to your website without hustle!
              </p>
            </div>
          }
        />
      <Footer/>
      </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js